<template>
  <div>
    <Modal v-model="showModal" title="编辑科目">
      <Form :model="courForm" :label-width="60" :rules="courseRules" ref="courForm">
        <FormItem label="名称" prop="name">
          <Input type="text" v-model="courForm.name" placeholder="请输入名称"/>
        </FormItem>
        <FormItem label="类型" prop="type">
          <RadioGroup v-model="courForm.type" >
            <Radio :label="1" :disabled="chooseType">一对一</Radio>
            <Radio :label="2" :disabled="chooseType">一对多</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="类型" prop="cate_id">
          <Select v-model="courForm.cate_id">
            <Option v-for="(item,index) in cateList" :key="index" :value="item.id">{{item.name}}
            </Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="small" @click="saveCourse('courForm')">确认</Button>
        <Button type="default" size="small" @click="modelcancle">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name: 'course_Form',
    data() {
      return {
        showModal: false,
        chooseType:false,
        id: null,
        courForm: {
          name: '',
          type: 0,
          cate_id: '',
        },
        courseRules: {
          name: [{required: true, message: '请输入科目名称', trigger: 'blur'}],
          cate_id: [{required: true, type: 'number', message: '请选择科目类别', trigger: 'change'}],
        },
        cateList: []
      }
    },
    methods: {
      getCateList() {
        this.cateList = []
        this.$api.course.getCateList().then(res => {
          if (res.state == "ok") {
            this.cateList = res.cateList
          }
        })
      },
      getCourseDetail() {
        this.chooseType=true
        this.$api.course.getCourseDetail({id: this.id}).then(res => {
          if (res.state == "ok") {
            this.courForm = res.detail;
          }
        })
      },
      saveCourse(name) {
        let self = this
        self.$refs[name].validate((valid) => {
          if (valid) {
            self.$api.course.saveCourse(this.packagingFormData()).then(res => {
              if (res.state == "ok") {
                this.$Message.success("保存成功");
                this.$refs.courForm.resetFields()
                this.$emit("refresh")
              } else {
                this.$Message.error(res.msg);
              }
              this.showModal = false
            })
          }
        })
      },
      packagingFormData() {
        let postFormData = {};
        for (var i in this.courForm) {
          if (this.courForm.hasOwnProperty(i)) {
            postFormData['course.' + i] = this.courForm[i];
          }
        }
        postFormData['course.id'] = this.id
        return postFormData;
      },
      modelcancle() {
        this.$refs.courForm.resetFields()
        this.showModal=false
      }
    }
  }
</script>
